import { AssetEmbedType } from 'library/ts/model/enums/content/AssetEmbedType';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { DesktopAssetUrlResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/DesktopAssetUrlResourceConfigBuilder';
import { DesktopCIDResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/DesktopCIDResourceConfigBuilder';
import { DesktopPIDResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/DesktopPIDResourceConfigBuilder';
import { HTML5AssetUrlResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/HTML5AssetUrlResourceConfigBuilder';
import { HTML5CIDResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/HTML5CIDResourceConfigBuilder';
import { HTML5PIDResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/HTML5PIDResourceConfigBuilder';
export class AviaFactory extends AbstractTagClass {
    #resourceConfigBuilder;
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaFactory'
        });
    }
    #initAviaResourceConfigBuilder() {
        return new Promise((resolve, reject) => {
            this.#resourceConfigBuilder = undefined;
            const assetEmbedType = this.tag.model.contentUtilities.assetEmbedType(this.params);
            const initDesktopResourceConfigBuilder = () => {
                if (this.utils.Type.isEmpty(assetEmbedType)) {
                    this?.logger?.warn('initDesktopResourceConfigBuilder', 'assetEmbedType is missing/invalid... setting resourceConfigBuilder to undefined', 'assetEmbedType:', assetEmbedType);
                    this.#resourceConfigBuilder = undefined;
                    return;
                }
                switch (assetEmbedType) {
                    case AssetEmbedType.ASSET_URL:
                        this.#resourceConfigBuilder = new DesktopAssetUrlResourceConfigBuilder({ tag: this.tag });
                        break;
                    case AssetEmbedType.PID:
                        this.#resourceConfigBuilder = new DesktopPIDResourceConfigBuilder({ tag: this.tag });
                        break;
                    case AssetEmbedType.CID:
                        this.#resourceConfigBuilder = new DesktopCIDResourceConfigBuilder({ tag: this.tag });
                        break;
                    default:
                        this?.logger?.warn('initDesktopResourceConfigBuilder', 'assetEmbedType not supported... setting resourceConfigBuilder to undefined', 'assetEmbedType:', assetEmbedType);
                        this.#resourceConfigBuilder = undefined;
                }
            };
            const initHTML5ResourceConfigBuilder = () => {
                switch (assetEmbedType) {
                    case AssetEmbedType.ASSET_URL:
                        this.#resourceConfigBuilder = new HTML5AssetUrlResourceConfigBuilder({ tag: this.tag });
                        break;
                    case AssetEmbedType.PID:
                        this.#resourceConfigBuilder = new HTML5PIDResourceConfigBuilder({ tag: this.tag });
                        break;
                    case AssetEmbedType.CID:
                        this.#resourceConfigBuilder = new HTML5CIDResourceConfigBuilder({ tag: this.tag });
                        break;
                    default:
                        this?.logger?.warn('initHTML5ResourceConfigBuilder', 'assetEmbedType not supported... setting resourceConfigBuilder to undefined', 'assetEmbedType:', assetEmbedType);
                        this.#resourceConfigBuilder = undefined;
                }
            };
            switch (this.params.SYSTEM.embedType) {
                case EmbedType.DESKTOP:
                case EmbedType.MOBILE_WEB:
                    initDesktopResourceConfigBuilder();
                    break;
                case EmbedType.HTML5:
                    initHTML5ResourceConfigBuilder();
                    break;
                default:
                    this?.logger?.warn('initAviaResourceConfigBuilder', 'embedType not supported... setting resourceConfigBuilder to undefined', 'params.SYSTEM.embedType:', this.params.SYSTEM.embedType);
                    this.#resourceConfigBuilder = undefined;
            }
            this?.logger?.log('initAviaResourceConfigBuilder', 'resourceConfigBuilder:', this.#resourceConfigBuilder);
            resolve({ msg: 'done', success: true, resourceConfigBuilder: this.#resourceConfigBuilder });
        });
    }
    createPlayer(playerOptions) {
        return new Promise((resolve, reject) => {
            window.avia.createVideoPlayer(playerOptions).then((player) => {
                this?.logger?.log('createPlayer Success:', 'AviaPlayer:', player);
                resolve({ msg: 'Player created', player: player });
            }).catch((error) => {
                this?.logger?.warn('createPlayer Error:', error);
                reject({ msg: 'Player creation failed', result: error });
            });
        });
    }
    destroyPlayer(aviaPlayerWrapper) {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isEmpty(aviaPlayerWrapper?.API)) {
                this?.logger?.log('destroyPlayer: player instance is:', aviaPlayerWrapper, 'Resolve the promise');
                resolve({ msg: 'Player destroyed', success: true });
            }
            else {
                aviaPlayerWrapper.API.removePlayerEventListener().then((data) => {
                    this?.logger?.log('destroyPlayer: unsubscribed from avia events');
                    window.avia.removeVideoPlayer(aviaPlayerWrapper?.adaptedPlayerInstance?.id).then(() => {
                        this?.logger?.log('destroyPlayer Success');
                        aviaPlayerWrapper.adaptedPlayerInstance = undefined;
                        resolve({ msg: 'Player destroyed', success: true });
                    }).catch((error) => {
                        this?.logger?.warn('destroyPlayer Error:', error);
                        reject({ msg: 'Player destruction failed', result: error });
                    });
                });
            }
        });
    }
    getResourceConfig() {
        return new Promise((resolve) => {
            this.#initAviaResourceConfigBuilder().then((data) => {
                if (this.utils.Type.isFunction(data?.resourceConfigBuilder?.getResult)) {
                    data?.resourceConfigBuilder?.getResult().then((data) => {
                        this?.logger?.log('this.#resourceConfigBuilder.getResult()=>', data);
                        const baseResourceConfig = data?.resource;
                        const promiseArray = [
                            () => this.tag.model.siteUtilities.getSiteSessionData(`${this.name}.getResourceConfig`)
                        ];
                        this.utils.Function.runPromiseArray(promiseArray).then(() => {
                            this?.logger?.log('getResourceConfig:', baseResourceConfig);
                            resolve({ msg: 'Resource config', resource: baseResourceConfig });
                        });
                    });
                }
                else {
                    this?.logger?.warn('this.#resourceConfigBuilder is undefined');
                }
            });
        });
    }
}
